import {
  Typography,
  Box,
  TableCell,
  TableRow,
  Stack,
} from '@mui/material';

import { ApplicationItem } from "@/types/admin_types";
import { useState } from 'react';
import JobApplicationDetails from './ApplicationDetails';
import CustomDialog from '@/components/custom-dialog/CustomDialog';
import { Button } from '@/components/ui/button';
import { Eye, Trash2 } from 'lucide-react';
import DeleteElComponent from '../../_components/DeleteElComponent';
import UpdateApplicationStatus from './UpdateApplicationStatus';

type Props = {
  el: ApplicationItem;
  index: number;
}
export default function ApplicationRow({ el, index }: Props) {

  const [openUpdate, setOpenUpdate] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  return (
    <>
      <TableRow hover key={el?.id}>
        <TableCell style={{ paddingLeft: 30, paddingRight: 30 }}>
          <Stack spacing={2} direction="row" >
            <Box>
              <Typography color="black" fontSize={14} variant="h6" fontWeight="400">
                {index + 1} 
              </Typography>
            </Box>
          </Stack>
        </TableCell>
        <TableCell>
          <Stack spacing={2} direction="row" >
            <Box>
              <Typography color="black" fontSize={14} variant="h6" fontWeight="400">
                {el?.full_name}
              </Typography>
            </Box>
          </Stack>
        </TableCell>
        <TableCell>
          <Stack spacing={2} direction="row" >
            <Box>
              <Typography color="black" fontSize={14} variant="h6" fontWeight="400">
                {el?.application_type}
              </Typography>
            </Box>
          </Stack>
        </TableCell>
        <TableCell>
          <Stack spacing={2} direction="row" >
            <Box>
              <Typography color="black" fontSize={14} variant="h6" fontWeight="400">
                {el?.email}
              </Typography>
            </Box>
          </Stack>
        </TableCell>
        <TableCell>
          <Stack spacing={2} direction="row" >
            <Box>
              <Typography color="black" fontSize={14} variant="h6" fontWeight="400">
                {el?.nationality}
              </Typography>
            </Box>
          </Stack>
        </TableCell>
        
        <TableCell>
          <Stack spacing={2} direction="row" >
            <Box>
              <Typography fontSize={14} variant="h6" fontWeight="400" 
                className={`px-3 py-1 rounded-full text-sm ${
                  el.status === "pending"
                    ? "bg-yellow-100 text-yellow-700"
                    : el.status === "approved"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {el?.status}
              </Typography>
            </Box>
          </Stack>
        </TableCell>

        <TableCell>
          <Stack display='flex' gap={1} direction="row">
            <CustomDialog
              open={openDetails}
              setOpen={setOpenDetails}
              withHeader={false}
              trigger={
                <Button variant="ghost"
                  className="p-2 border"
                  type='button'
                  onClick={() => setOpenDetails(true)}
                >
                  <Eye strokeWidth={3} className="text-[#73b9d7]"/>
                </Button>
              }
              components={
                <JobApplicationDetails application={el}/>
              }
            />

            <UpdateApplicationStatus el={el} open={openUpdate} setOpen={setOpenUpdate}/>

            <CustomDialog
              open={openDelete}
              setOpen={setOpenDelete}
              title='Delete File'
              subtitle='Are you sure you want to delete this file?'
              trigger={
                <Button variant="ghost" className="p-2 border">
                  <Trash2
                    strokeWidth={2.2}
                    size={18}
                    className=" text-rose-700"
                  />
                </Button>
              }
              components={
                <DeleteElComponent
                  preview={el.full_name}
                  setOpen={setOpenDelete} 
                  url={`/api/v1/admin/applications/${el?.id}`}
                  invalidate='messages'
                  disabled
                />
              }
            />
          </Stack>
        </TableCell>
      </TableRow>
    </>
  )
}
